import { Card, CardContent, Typography, Box } from "@mui/material";
import WidgetsIcon from "@mui/icons-material/Widgets";

/**
 * Placeholder. Uso futuro.
 */
export const DealsChart = () => {
  return (
    <Card sx={{ minHeight: 320 }}>
      <CardContent sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        <Box display="flex" alignItems="center" gap={1} mb={2}>
          <WidgetsIcon color="disabled" />
          <Typography variant="h6" color="text.secondary">
            Em breve
          </Typography>
        </Box>
        <Typography variant="body2" color="text.secondary">
          Reservado para uso futuro.
        </Typography>
      </CardContent>
    </Card>
  );
};
